<template>
  <div class="subscription-summary">
    <span class="dummy">{{ summary.id }}</span>

    <div class="subscription-summary__main">
      <div class="main__name">
        <span>{{ $t('label.selected_plan') }}:</span>
      </div>
      <div class="main__options">
        <span>{{ summary.group.name }} ({{ summary.name }})</span>
      </div>
    </div>

    <hr>

    <div class="subscription-summary__main">
      <div class="main__name">
        <span>{{ $t('label.basic_cost') }}:</span>
      </div>
      <div class="main__options">
        <template v-for="(price, index) in _get(summary, 'PriceOptions', [])">
          <span v-if="checkCurrency(price)">
            {{ _get(price, 'price', 0) | number-format(2) }} {{ _get(price, 'Currency.symbol') }} {{ _get(price, 'PaymentPlan.suffix') }}
          </span>
        </template>
      </div>
    </div>

    <hr>

    <div class="subscription-summary__main">
      <div class="main__name">
        <span>{{ $t('label.extra_options') }}:</span>
      </div>
      <div class="main__options">
        <span v-if="haveExtraFeatures">
          <span v-for="priceOption in _get(featuresPrice, 'priceOptions', [])">
            {{ _get(priceOption, 'price') | number-format(2) }} {{ _get(priceOption, 'currency') }} {{ _get(priceOption, 'payment') }}
          </span>
        </span>
        <span v-else>{{ $t('label.no_extra_options_added') }}</span>
      </div>
    </div>

    <hr class="is-double">

    <div class="subscription-summary__main">
      <div class="main__name main__name--total">
        <span>{{ $t('label.total') }}:</span>
      </div>
      <div class="main__options">
        <span v-for="priceOption in _get(totalPrice, 'priceOptions', [])">
          {{ _get(priceOption, 'price') }} {{ _get(priceOption, 'currency') }} {{ _get(priceOption, 'payment') }}
        </span>
      </div>
    </div>

  </div>
</template>

<script>
/* eslint-disable object-shorthand */
import Vue from 'vue';
import { get, each, has } from 'lodash';

export default {
  name: 'cmpt-subscription-summary',
  props: {
    summary: {
      required: true,
      default: null,
    },
    selectedCurrencyID: {
      required: true,
      default: null,
    },
    selectedPaymentPlanID: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
      haveExtraFeatures: false,
      featuresPrice: {},
      totalPrice: {},
    };
  },
  computed: {
    nextStep() {},
  },
  methods: {
    checkCurrency(price) {
      return get(price, 'Currency.id') === this.selectedCurrencyID;
    },
    checkCurrencyAndPrice(price) {
      return Number(price.price) !== 0 && get(price, 'Currency.id') === this.selectedCurrencyID;
    },
    setTotalPrice() {
      Vue.set(this.totalPrice, 'priceOptions', {});

      each(get(this.summary, 'PriceOptions', []), (price) => {
        // console.log('summary PriceOptions', price);
        if (this.checkCurrency(price)) {
          const code = get(price, 'PaymentPlan.code');

          Vue.set(this.totalPrice.priceOptions, code, {
            price: 0,
            payment: null,
            currency: null,
            payment_plan: null,
          });

          this.totalPrice.priceOptions[price.PaymentPlan.code].price += Number(price.price);
          this.totalPrice.priceOptions[price.PaymentPlan.code].currency = get(price, 'Currency.symbol');
          this.totalPrice.priceOptions[price.PaymentPlan.code].payment = get(price, 'PaymentPlan.suffix');
          this.totalPrice.priceOptions[price.PaymentPlan.code].payment_plan = get(price, 'PaymentPlan.code');
        }
      });
      // end ~ PriceOptions

      each(get(this.featuresPrice, 'priceOptions', []), (price) => {
        const paymentPlan = get(price, 'payment_plan', false);
        if (paymentPlan && has(this.totalPrice, `priceOptions.${paymentPlan}`)) {
          const value = get(price, 'price', 0);
          this.totalPrice.priceOptions[paymentPlan].price += Number(value);
        }
      });
      // end ~ PriceOptions
    },
    setExtraFeaturesPrice() {
      const sum = {};

      const features = get(this.summary, 'features', []);

      this.haveExtraFeatures = false;
      Vue.set(this.featuresPrice, 'priceOptions', {});

      each(features, (feature) => {
        // console.log('feature', feature);

        each(feature, (option) => {
          // console.log('option', option);

          each(option.PriceOptions, (price) => {
            // console.log('PriceOptions', price);

            if (this.checkCurrencyAndPrice(price)) {
              const code = get(price, 'PaymentPlan.code');

              if (!sum[code]) {
                sum[code] = 0;
                this.haveExtraFeatures = true;

                Vue.set(this.featuresPrice.priceOptions, code, {
                  price: 0,
                  currency: get(price, 'Currency.symbol'),
                  payment: get(price, 'PaymentPlan.suffix'),
                  payment_plan: code,
                });
              }

              sum[code] += Number(get(price, 'price', 0));
            }
          });
          // end ~ PriceOptions
        });
        // end ~ feature
      });
      // end ~ features

      each(sum, (value, key) => {
        Vue.set(this.featuresPrice.priceOptions[key], 'price', value);
      });

      this.setTotalPrice();
    },
  },
  watch: {
    'summary.features': {
      handler: function () {
        console.log('features changes');
        this.setExtraFeaturesPrice();
      },
      deep: true,
    },
    selectedCurrencyID() {
      this.setExtraFeaturesPrice();
    },
  },
  created() {
    this.setExtraFeaturesPrice();
  },
};
</script>

<style lang="scss" scoped>
  $margin: 6px;

  .subscription-summary {
    margin: $margin;
    margin-bottom: 0;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .dummy {
      display: none;
    }

    hr {
      background-color: #fff;
      margin: $margin (-1 * $margin) $margin (-1 * $margin);
      &.is-double {
        height: 2px;
      }
    }

    .subscription-summary__main {
      flex-grow: 1;
      display: flex;
      justify-content: flex-end;

      .main__name, .main__options {
        display: flex;
        flex: 0 0 50%;
        justify-content: flex-end;
        > * {
          color: #fff;
          margin: 0 0.5em;
          font-weight: 400;
          text-shadow: 0 -1px 0 rgba(0, 0, 0, .2);
        }
        &.main__name--total {
          font-weight: 800;
        }
      }

      .main__options {
        justify-content: flex-start;
      }

    }

    .subscription-summary__more-less {
      flex-grow: 1;
      margin-right: 1em;

      > * {

        a {
          font-size: 0.85em;
          color: rgba(0, 0, 0, .25);
          text-shadow: 0 1px 0 rgba(255, 255, 255, .2);
          &:hover {
            color: rgba(255, 255, 255, .85);
            text-shadow: 0 -1px 0 rgba(0, 0, 0, .2);
          }
          > i {
            margin-right: 0.75em;
          }
        }

        position: relative;
        height: auto;
        overflow: hidden;
        line-height: 1.15;
        text-align: center;

        &:after, &:before {
            position: absolute;
            content: '';
            z-index: 3;
            width: 50%;
            top: 50%;
            height: 0;
            border-top: 1px solid rgba(0, 0, 0, .1);
            border-bottom: 1px solid rgba(255, 255, 255, .2);
        }

        &:before {
            margin-left: -webkit-calc(-50% - 1em);
            margin-left: calc(-50% - 1em);
        }

        &:after {
            margin-left: 1em;
        }
      }

    } // end ~ subscription-summary__more-less

    .subscription-summary__more {
      flex-grow: 1;
      display: flex;
      flex-direction: column;

      .more-option-description {
        color: #fff;
        margin: 0 0.5em;
        font-size: 0.85em;
        .more-option-description--feature-name {
          font-weight: 600;
        }
      }

      hr {
        margin: $margin (-1 * $margin) 0 (-1 * $margin);
      }
    }

    &:last-child {
      margin-bottom: $margin;
      .subscription-summary__more {
        hr { display: none; }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/subscription/cmpt-subscription-summary.vue